import './utils/installStorageShims';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ImpersonationProvider } from './context/ImpersonationContext';
import ErrorBoundary from './components/ErrorBoundary';
import { initGlobalErrorCapture } from './utils/errorReporting';
import { initProductTracking } from './services/productTracking';
import { initClarityTags } from './services/clarityTags';
import { queryClient } from './services/sharedCache';

initGlobalErrorCapture();

// Clarity: build + design tags now, member identify once the customer id is known.
initClarityTags();

// Statsig, for the per-product click score (product_impression / product_click /
// product_add). Starts under the stored Recharge customer id and is re-keyed to
// the Shopify customer id by identifyMember() once subscriptions resolve, so
// portal activity joins to the same member's storefront activity. Failure is
// swallowed inside the service — a member must never be blocked by analytics.
initProductTracking();

// Register the (network-passthrough) service worker. Android Chrome requires
// an active service worker with a fetch handler before it offers the
// "Install app" prompt; iOS ignores it entirely.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((error) => console.error('Service worker registration failed:', error));
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ImpersonationProvider>
          <App />
        </ImpersonationProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
